import { render } from "./StoriesView.vue?vue&type=template&id=de5574b0&scoped=true"
import script from "./StoriesView.vue?vue&type=script&lang=js"
export * from "./StoriesView.vue?vue&type=script&lang=js"

import "./StoriesView.vue?vue&type=style&index=0&id=de5574b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-de5574b0"

export default script